// Nanakshahi Calendar 2026 Data
// Source: punjabdata.com

export const NANAKSHAHI_CALENDAR_2026 = {
  // January 2026
  "2026-01-01": { desi: "18 ਪੋਹ", tithi: "ਪੋਹ ਸੁਦੀ 13", festival: "ਨਵਾਂ ਸਾਲ", festival_en: "New Year" },
  "2026-01-03": { desi: "20 ਪੋਹ", tithi: "ਪੋਹ ਸੁਦੀ ਪੂਰਨਮਾਸ਼ੀ", festival: "ਪੂਰਨਮਾਸ਼ੀ", festival_en: "Puranmashi" },
  "2026-01-13": { desi: "30 ਪੋਹ", tithi: "ਮਾਘ ਵਦੀ 10", festival: "ਲੋਹੜੀ", festival_en: "Lohri" },
  "2026-01-14": { desi: "1 ਮਾਘ", tithi: "ਮਾਘ ਵਦੀ 11", festival: "ਮਾਘੀ, ਸੰਗਰਾਂਦ", festival_en: "Maghi, Sangrand", sangrand: true },
  "2026-01-23": { desi: "10 ਮਾਘ", tithi: "ਮਾਘ ਸੁਦੀ 5", festival: "ਬਸੰਤ ਪੰਚਮੀ", festival_en: "Basant Panchmi" },
  "2026-01-26": { desi: "13 ਮਾਘ", tithi: "ਮਾਘ ਸੁਦੀ 8", festival: "ਗਣਤੰਤਰ ਦਿਵਸ", festival_en: "Republic Day" },
  "2026-01-27": { desi: "14 ਮਾਘ", tithi: "ਮਾਘ ਸੁਦੀ 9", festival: "ਬਾਬਾ ਦੀਪ ਸਿੰਘ ਜੀ ਜਨਮ ਦਿਵਸ", festival_en: "Baba Deep Singh Ji Birthday" },
  "2026-01-31": { desi: "18 ਮਾਘ", tithi: "ਮਾਘ ਸੁਦੀ 13-14", festival: "ਗੁਰੂ ਹਰਿ ਰਾਇ ਜੀ ਜਨਮ ਗੁਰਪੁਰਬ", festival_en: "Guru Har Rai Ji Birthday" },

  // February 2026
  "2026-02-01": { desi: "19 ਮਾਘ", tithi: "ਮਾਘ ਸੁਦੀ ਪੂਰਨਮਾਸ਼ੀ", festival: "ਗੁਰੂ ਰਵਿਦਾਸ ਜਯੰਤੀ", festival_en: "Guru Ravidas Jayanti" },
  "2026-02-11": { desi: "29 ਮਾਘ", tithi: "ਫੱਗਣ ਵਦੀ 9", festival: "ਸਾਹਿਬਜ਼ਾਦਾ ਅਜੀਤ ਸਿੰਘ ਜੀ ਜਨਮ", festival_en: "Sahibzada Ajit Singh Ji Birthday" },
  "2026-02-12": { desi: "1 ਫੱਗਣ", tithi: "ਫੱਗਣ ਵਦੀ 10", festival: "ਸੰਗਰਾਂਦ", festival_en: "Sangrand", sangrand: true },
  "2026-02-15": { desi: "4 ਫੱਗਣ", tithi: "ਫੱਗਣ ਵਦੀ 13", festival: "ਮਹਾ ਸ਼ਿਵਰਾਤਰੀ", festival_en: "Maha Shivratri" },
  "2026-02-21": { desi: "10 ਫੱਗਣ", tithi: "ਫੱਗਣ ਸੁਦੀ 4", festival: "ਸਾਕਾ ਨਨਕਾਣਾ ਸਾਹਿਬ", festival_en: "Saka Nankana Sahib" },

  // March 2026
  "2026-03-04": { desi: "21 ਫੱਗਣ", tithi: "ਚੇਤ ਵਦੀ 1", festival: "ਹੋਲੀ, ਹੋਲਾ ਮਹੱਲਾ", festival_en: "Holi, Hola Mohalla" },
  "2026-03-14": { desi: "1 ਚੇਤ", tithi: "ਚੇਤ ਵਦੀ 10", festival: "ਨਾਨਕਸ਼ਾਹੀ ਨਵਾਂ ਸਾਲ, ਸੰਗਰਾਂਦ", festival_en: "Nanakshahi New Year, Sangrand", sangrand: true },
  "2026-03-19": { desi: "6 ਚੇਤ", tithi: "ਚੇਤ ਵਦੀ ਮੱਸਿਆ", festival: "ਗੁਰੂ ਅਮਰਦਾਸ ਜੀ ਗੁਰਗੱਦੀ", festival_en: "Guru Amardas Ji Gurgaddi" },
  "2026-03-21": { desi: "8 ਚੇਤ", tithi: "ਚੇਤ ਸੁਦੀ 3", festival: "ਈਦ-ਉਲ-ਫਿਤਰ", festival_en: "Id-ul-Fitr" },
  "2026-03-22": { desi: "9 ਚੇਤ", tithi: "ਚੇਤ ਸੁਦੀ 4", festival: "ਗੁਰੂ ਅੰਗਦ ਦੇਵ ਜੀ ਜੋਤੀ ਜੋਤ", festival_en: "Guru Angad Dev Ji Jyoti Jot" },
  "2026-03-23": { desi: "10 ਚੇਤ", tithi: "ਚੇਤ ਸੁਦੀ 5", festival: "ਭਗਤ ਸਿੰਘ ਸ਼ਹੀਦੀ ਦਿਵਸ", festival_en: "Shaheed Bhagat Singh Day" },
  "2026-03-26": { desi: "13 ਚੇਤ", tithi: "ਚੇਤ ਸੁਦੀ 8", festival: "ਰਾਮ ਨੌਮੀ", festival_en: "Ram Navmi" },

  // April 2026
  "2026-04-01": { desi: "19 ਚੇਤ", tithi: "ਚੇਤ ਸੁਦੀ 14", festival: "ਗੁਰੂ ਹਰਕ੍ਰਿਸ਼ਨ ਜੀ ਜੋਤੀ ਜੋਤ", festival_en: "Guru Harkrishan Ji Jyoti Jot" },
  "2026-04-07": { desi: "25 ਚੇਤ", tithi: "ਵੈਸਾਖ ਵਦੀ 5", festival: "ਗੁਰੂ ਤੇਗ ਬਹਾਦਰ ਜੀ ਜਨਮ ਗੁਰਪੁਰਬ", festival_en: "Guru Teg Bahadur Ji Birthday" },
  "2026-04-09": { desi: "27 ਚੇਤ", tithi: "ਵੈਸਾਖ ਵਦੀ 7", festival: "ਗੁਰੂ ਅਰਜਨ ਦੇਵ ਜੀ ਜਨਮ ਗੁਰਪੁਰਬ", festival_en: "Guru Arjan Dev Ji Birthday" },
  "2026-04-13": { desi: "31 ਚੇਤ", tithi: "ਵੈਸਾਖ ਵਦੀ 11", festival: "ਸਿੱਖ ਦਸਤਾਰ ਦਿਵਸ", festival_en: "Sikh Dastar Diwas" },
  "2026-04-14": { desi: "1 ਵੈਸਾਖ", tithi: "ਵੈਸਾਖ ਵਦੀ 12", festival: "ਵਿਸਾਖੀ, ਸੰਗਰਾਂਦ", festival_en: "Vaisakhi, Sangrand", sangrand: true },
  "2026-04-18": { desi: "5 ਵੈਸਾਖ", tithi: "ਵੈਸਾਖ ਸੁਦੀ 1", festival: "ਗੁਰੂ ਅੰਗਦ ਦੇਵ ਜੀ ਪ੍ਰਕਾਸ਼ ਦਿਵਸ", festival_en: "Guru Angad Dev Ji Parkash Divas" },
  "2026-04-30": { desi: "17 ਵੈਸਾਖ", tithi: "ਵੈਸਾਖ ਸੁਦੀ 14", festival: "ਗੁਰੂ ਅਮਰਦਾਸ ਜੀ ਪ੍ਰਕਾਸ਼ ਗੁਰਪੁਰਬ", festival_en: "Guru Amardas Ji Parkash" },

  // May 2026
  "2026-05-01": { desi: "18 ਵੈਸਾਖ", tithi: "ਵੈਸਾਖ ਸੁਦੀ ਪੂਰਨਮਾਸ਼ੀ", festival: "ਮਜ਼ਦੂਰ ਦਿਵਸ, ਬੁੱਧ ਜਯੰਤੀ", festival_en: "Labour Day, Buddha Jayanti" },
  "2026-05-10": { desi: "27 ਵੈਸਾਖ", tithi: "ਜੇਠ ਵਦੀ 8", festival: "ਗੁਰੂ ਹਰਗੋਬਿੰਦ ਜੀ ਗੁਰਗੱਦੀ", festival_en: "Guru Hargobind Ji Gurgaddi" },
  "2026-05-15": { desi: "1 ਜੇਠ", tithi: "ਜੇਠ ਵਦੀ 13-14", festival: "ਸੰਗਰਾਂਦ", festival_en: "Sangrand", sangrand: true },

  // June 2026
  "2026-06-04": { desi: "21 ਜੇਠ", tithi: "ਜੇਠ ਵਦੀ 4", festival: "ਆਪ੍ਰੇਸ਼ਨ ਬਲੂ ਸਟਾਰ", festival_en: "Operation Blue Star" },
  "2026-06-15": { desi: "1 ਹਾੜ", tithi: "ਜੇਠ ਵਦੀ ਮੱਸਿਆ", festival: "ਸੰਗਰਾਂਦ", festival_en: "Sangrand", sangrand: true },
  "2026-06-18": { desi: "4 ਹਾੜ", tithi: "ਜੇਠ ਸੁਦੀ 4", festival: "ਗੁਰੂ ਅਰਜਨ ਦੇਵ ਜੀ ਸ਼ਹੀਦੀ ਗੁਰਪੁਰਬ", festival_en: "Guru Arjan Dev Ji Shaheedi" },
  "2026-06-25": { desi: "11 ਹਾੜ", tithi: "ਜੇਠ ਸੁਦੀ 11", festival: "ਬਾਬਾ ਬੰਦਾ ਸਿੰਘ ਬਹਾਦਰ ਸ਼ਹੀਦੀ", festival_en: "Baba Banda Singh Bahadur Shaheedi" },
  "2026-06-29": { desi: "15 ਹਾੜ", tithi: "ਜੇਠ ਸੁਦੀ ਪੂਰਨਮਾਸ਼ੀ", festival: "ਭਗਤ ਕਬੀਰ ਜਯੰਤੀ", festival_en: "Bhagat Kabir Jayanti" },
  "2026-06-30": { desi: "16 ਹਾੜ", tithi: "ਹਾੜ ਵਦੀ 1", festival: "ਗੁਰੂ ਹਰਗੋਬਿੰਦ ਜੀ ਜਨਮ ਦਿਵਸ", festival_en: "Guru Hargobind Ji Birthday" },

  // July 2026
  "2026-07-02": { desi: "18 ਹਾੜ", tithi: "ਹਾੜ ਵਦੀ 2", festival: "ਅਕਾਲ ਤਖ਼ਤ ਸਾਹਿਬ ਸਿਰਜਣਾ ਦਿਵਸ", festival_en: "Akal Takht Sahib Day" },
  "2026-07-09": { desi: "25 ਹਾੜ", tithi: "ਹਾੜ ਵਦੀ 10-11", festival: "ਭਾਈ ਮਨੀ ਸਿੰਘ ਜੀ ਸ਼ਹੀਦੀ", festival_en: "Bhai Mani Singh Ji Shaheedi" },
  "2026-07-16": { desi: "1 ਸਾਵਣ", tithi: "ਹਾੜ ਸੁਦੀ 2", festival: "ਭਾਈ ਤਾਰੂ ਸਿੰਘ ਜੀ ਸ਼ਹੀਦੀ, ਸੰਗਰਾਂਦ", festival_en: "Bhai Taru Singh Ji Shaheedi, Sangrand", sangrand: true },
  "2026-07-24": { desi: "9 ਸਾਵਣ", tithi: "ਹਾੜ ਸੁਦੀ 10", festival: "ਮੀਰੀ ਪੀਰੀ ਦਿਵਸ", festival_en: "Miri Piri Diwas" },
  "2026-07-29": { desi: "14 ਸਾਵਣ", tithi: "ਹਾੜ ਸੁਦੀ ਪੂਰਨਮਾਸ਼ੀ", festival: "ਗੁਰੂ ਪੂਰਨਿਮਾ", festival_en: "Guru Purnima" },

  // August 2026
  "2026-08-07": { desi: "23 ਸਾਵਣ", tithi: "ਸਾਵਣ ਵਦੀ 9", festival: "ਗੁਰੂ ਹਰਕ੍ਰਿਸ਼ਨ ਜੀ ਜਨਮ ਗੁਰਪੁਰਬ", festival_en: "Guru Harkrishan Ji Birthday" },
  "2026-08-15": { desi: "31 ਸਾਵਣ", tithi: "ਸਾਵਣ ਸੁਦੀ 3", festival: "ਸੁਤੰਤਰਤਾ ਦਿਵਸ", festival_en: "Independence Day" },
  "2026-08-17": { desi: "1 ਭਾਦੋਂ", tithi: "ਸਾਵਣ ਸੁਦੀ 5", festival: "ਨਾਗ ਪੰਚਮੀ, ਸੰਗਰਾਂਦ", festival_en: "Nag Panchami, Sangrand", sangrand: true },
  "2026-08-28": { desi: "12 ਭਾਦੋਂ", tithi: "ਸਾਵਣ ਸੁਦੀ ਪੂਰਨਮਾਸ਼ੀ", festival: "ਰੱਖੜੀ, ਬਾਬਾ ਬਕਾਲਾ ਜੋੜ ਮੇਲਾ", festival_en: "Rakhri, Baba Bakala Jor Mela" },
  "2026-08-30": { desi: "14 ਭਾਦੋਂ", tithi: "ਭਾਦੋਂ ਵਦੀ 2", festival: "ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਜੀ ਸੰਪੂਰਨਤਾ ਦਿਵਸ", festival_en: "Guru Granth Sahib Sampurnata Diwas" },

  // September 2026
  "2026-09-04": { desi: "19 ਭਾਦੋਂ", tithi: "ਭਾਦੋਂ ਵਦੀ 8", festival: "ਜਨਮਾਸ਼ਟਮੀ", festival_en: "Janmashtami" },
  "2026-09-12": { desi: "27 ਭਾਦੋਂ", tithi: "ਭਾਦੋਂ ਸੁਦੀ 1", festival: "ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਜੀ ਪਹਿਲਾ ਪ੍ਰਕਾਸ਼ ਪੁਰਬ", festival_en: "Guru Granth Sahib Ji First Parkash" },
  "2026-09-14": { desi: "29 ਭਾਦੋਂ", tithi: "ਭਾਦੋਂ ਸੁਦੀ 3", festival: "ਗੁਰੂ ਰਾਮਦਾਸ ਜੀ ਜੋਤੀ ਜੋਤ, ਗਣੇਸ਼ ਚਤੁਰਥੀ", festival_en: "Guru Ramdas Ji Jyoti Jot, Ganesh Chaturthi" },
  "2026-09-17": { desi: "1 ਅੱਸੂ", tithi: "ਭਾਦੋਂ ਸੁਦੀ 6", festival: "ਸੰਗਰਾਂਦ", festival_en: "Sangrand", sangrand: true },
  "2026-09-24": { desi: "8 ਅੱਸੂ", tithi: "ਭਾਦੋਂ ਸੁਦੀ 13", festival: "ਗੁਰੂ ਰਾਮਦਾਸ ਜੀ ਗੁਰਗੱਦੀ", festival_en: "Guru Ramdas Ji Gurgaddi" },
  "2026-09-28": { desi: "12 ਅੱਸੂ", tithi: "ਅੱਸੂ ਵਦੀ 2", festival: "ਸ਼ਹੀਦ ਭਗਤ ਸਿੰਘ ਜਨਮ ਦਿਵਸ", festival_en: "Shaheed Bhagat Singh Birthday" },

  // October 2026
  "2026-10-02": { desi: "16 ਅੱਸੂ", tithi: "ਅੱਸੂ ਵਦੀ 6", festival: "ਗਾਂਧੀ ਜਯੰਤੀ", festival_en: "Gandhi Jayanti" },
  "2026-10-05": { desi: "19 ਅੱਸੂ", tithi: "ਅੱਸੂ ਵਦੀ 10", festival: "ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਜੀ ਜੋਤੀ ਜੋਤ", festival_en: "Guru Nanak Dev Ji Jyoti Jot" },
  "2026-10-11": { desi: "25 ਅੱਸੂ", tithi: "ਅੱਸੂ ਸੁਦੀ 1", festival: "ਨਵਰਾਤਰੇ ਸ਼ੁਰੂ", festival_en: "Navratri Starts" },
  "2026-10-16": { desi: "30 ਅੱਸੂ", tithi: "ਅੱਸੂ ਸੁਦੀ 6", festival: "ਬਾਬਾ ਬੰਦਾ ਸਿੰਘ ਬਹਾਦਰ ਜਨਮ ਦਿਵਸ", festival_en: "Baba Banda Singh Bahadur Birthday" },
  "2026-10-17": { desi: "1 ਕੱਤਕ", tithi: "ਅੱਸੂ ਸੁਦੀ 7", festival: "ਸੰਗਰਾਂਦ", festival_en: "Sangrand", sangrand: true },
  "2026-10-20": { desi: "4 ਕੱਤਕ", tithi: "ਅੱਸੂ ਸੁਦੀ 9", festival: "ਦੁਸਹਿਰਾ, ਨਵਰਾਤਰੇ ਖ਼ਤਮ", festival_en: "Dussehra, Navratri Ends" },
  "2026-10-26": { desi: "10 ਕੱਤਕ", tithi: "ਅੱਸੂ ਸੁਦੀ ਪੂਰਨਮਾਸ਼ੀ", festival: "ਵਾਲਮੀਕਿ ਜਯੰਤੀ", festival_en: "Valmiki Jayanti" },
  "2026-10-27": { desi: "11 ਕੱਤਕ", tithi: "ਕੱਤਕ ਵਦੀ 1-2", festival: "ਗੁਰੂ ਰਾਮਦਾਸ ਜੀ ਜਨਮ ਗੁਰਪੁਰਬ", festival_en: "Guru Ramdas Ji Birthday" },

  // November 2026
  "2026-11-01": { desi: "16 ਕੱਤਕ", tithi: "ਕੱਤਕ ਵਦੀ 7", festival: "ਨਵਾਂ ਪੰਜਾਬ ਦਿਵਸ", festival_en: "New Punjab Day" },
  "2026-11-03": { desi: "18 ਕੱਤਕ", tithi: "ਕੱਤਕ ਵਦੀ 9", festival: "ਗੁਰੂ ਹਰਿ ਰਾਇ ਜੀ ਜੋਤੀ ਜੋਤ", festival_en: "Guru Har Rai Ji Jyoti Jot" },
  "2026-11-08": { desi: "23 ਕੱਤਕ", tithi: "ਕੱਤਕ ਵਦੀ 14", festival: "ਦੀਵਾਲੀ, ਬੰਦੀ ਛੋੜ ਦਿਵਸ", festival_en: "Diwali, Bandi Chhorh Diwas" },
  "2026-11-11": { desi: "26 ਕੱਤਕ", tithi: "ਕੱਤਕ ਸੁਦੀ 2", festival: "ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਜੀ ਗੁਰਗੱਦੀ, ਭਾਈ ਦੂਜ", festival_en: "Guru Granth Sahib Ji Gurgaddi, Bhai Dooj" },
  "2026-11-13": { desi: "28 ਕੱਤਕ", tithi: "ਕੱਤਕ ਸੁਦੀ 4", festival: "ਮਹਾਰਾਜਾ ਰਣਜੀਤ ਸਿੰਘ ਜਨਮ ਦਿਵਸ", festival_en: "Maharaja Ranjit Singh Birthday" },
  "2026-11-14": { desi: "29 ਕੱਤਕ", tithi: "ਕੱਤਕ ਸੁਦੀ 5", festival: "ਗੁਰੂ ਗੋਬਿੰਦ ਸਿੰਘ ਜੀ ਜੋਤੀ ਜੋਤ", festival_en: "Guru Gobind Singh Ji Jyoti Jot" },
  "2026-11-15": { desi: "30 ਕੱਤਕ", tithi: "ਕੱਤਕ ਸੁਦੀ 6", festival: "ਬਾਬਾ ਦੀਪ ਸਿੰਘ ਜੀ ਸ਼ਹੀਦੀ", festival_en: "Baba Deep Singh Ji Shaheedi" },
  "2026-11-16": { desi: "1 ਮੱਘਰ", tithi: "ਕੱਤਕ ਸੁਦੀ 7", festival: "ਸੰਗਰਾਂਦ", festival_en: "Sangrand", sangrand: true },
  "2026-11-24": { desi: "9 ਮੱਘਰ", tithi: "ਕੱਤਕ ਸੁਦੀ ਪੂਰਨਮਾਸ਼ੀ", festival: "ਗੁਰੂ ਨਾਨਕ ਦੇਵ ਜੀ ਜਨਮ ਗੁਰਪੁਰਬ", festival_en: "Guru Nanak Dev Ji Birthday" },

  // December 2026
  "2026-12-12": { desi: "27 ਮੱਘਰ", tithi: "ਮੱਘਰ ਸੁਦੀ 3", festival: "ਗੁਰੂ ਗੋਬਿੰਦ ਸਿੰਘ ਜੀ ਗੁਰਗੱਦੀ", festival_en: "Guru Gobind Singh Ji Gurgaddi" },
  "2026-12-14": { desi: "29 ਮੱਘਰ", tithi: "ਮੱਘਰ ਸੁਦੀ 5", festival: "ਗੁਰੂ ਤੇਗ ਬਹਾਦਰ ਜੀ ਸ਼ਹੀਦੀ ਦਿਵਸ", festival_en: "Guru Teg Bahadur Ji Shaheedi Diwas" },
  "2026-12-16": { desi: "1 ਪੋਹ", tithi: "ਮੱਘਰ ਸੁਦੀ 7", festival: "ਸੰਗਰਾਂਦ", festival_en: "Sangrand", sangrand: true },
  "2026-12-21": { desi: "6 ਪੋਹ", tithi: "ਮੱਘਰ ਸੁਦੀ 12", festival: "ਸ਼ਹੀਦੀ ਜੋੜ ਮੇਲਾ ਚਮਕੌਰ ਸਾਹਿਬ", festival_en: "Shaheedi Jor Mela Chamkaur Sahib" },
  "2026-12-24": { desi: "9 ਪੋਹ", tithi: "ਪੋਹ ਵਦੀ 1", festival: "ਵੱਡੇ ਸਾਹਿਬਜ਼ਾਦੇ ਸ਼ਹੀਦੀ ਦਿਵਸ", festival_en: "Vade Sahibzade Shaheedi Diwas" },
  "2026-12-25": { desi: "10 ਪੋਹ", tithi: "ਪੋਹ ਵਦੀ 2", festival: "ਕ੍ਰਿਸਮਸ", festival_en: "Christmas" },
  "2026-12-26": { desi: "11 ਪੋਹ", tithi: "ਪੋਹ ਵਦੀ 3", festival: "ਸ਼ਹੀਦੀ ਜੋੜ ਮੇਲਾ ਫ਼ਤਿਹਗੜ੍ਹ ਸਾਹਿਬ", festival_en: "Shaheedi Jor Mela Fatehgarh Sahib" },
  "2026-12-28": { desi: "13 ਪੋਹ", tithi: "ਪੋਹ ਵਦੀ 5", festival: "ਛੋਟੇ ਸਾਹਿਬਜ਼ਾਦੇ ਅਤੇ ਮਾਤਾ ਗੁਜਰੀ ਜੀ ਸ਼ਹੀਦੀ", festival_en: "Chote Sahibzade & Mata Gujri Ji Shaheedi" }
};

// Desi month names
export const DESI_MONTHS = {
  "ਚੇਤ": { en: "Chet", start: "Mar 14" },
  "ਵੈਸਾਖ": { en: "Vaisakh", start: "Apr 14" },
  "ਜੇਠ": { en: "Jeth", start: "May 15" },
  "ਹਾੜ": { en: "Harh", start: "Jun 15" },
  "ਸਾਵਣ": { en: "Sawan", start: "Jul 16" },
  "ਭਾਦੋਂ": { en: "Bhadon", start: "Aug 17" },
  "ਅੱਸੂ": { en: "Assu", start: "Sep 17" },
  "ਕੱਤਕ": { en: "Kattak", start: "Oct 17" },
  "ਮੱਘਰ": { en: "Maghar", start: "Nov 16" },
  "ਪੋਹ": { en: "Poh", start: "Dec 16" },
  "ਮਾਘ": { en: "Maagh", start: "Jan 14" },
  "ਫੱਗਣ": { en: "Phagan", start: "Feb 12" }
};

// Get today's Nanakshahi date
export const getTodayNanakshahi = () => {
  const today = new Date();
  const dateStr = today.toISOString().split('T')[0];
  return NANAKSHAHI_CALENDAR_2026[dateStr] || null;
};

// Get upcoming festivals (next 7 days)
export const getUpcomingFestivals = (days = 7) => {
  const today = new Date();
  const upcoming = [];
  
  for (let i = 0; i <= days; i++) {
    const date = new Date(today);
    date.setDate(date.getDate() + i);
    const dateStr = date.toISOString().split('T')[0];
    
    if (NANAKSHAHI_CALENDAR_2026[dateStr] && NANAKSHAHI_CALENDAR_2026[dateStr].festival) {
      upcoming.push({
        date: dateStr,
        displayDate: date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }),
        ...NANAKSHAHI_CALENDAR_2026[dateStr]
      });
    }
  }
  
  return upcoming;
};

// Get current Desi month
export const getCurrentDesiMonth = () => {
  const today = new Date();
  const month = today.getMonth();
  const day = today.getDate();
  
  // Approximate mapping
  if ((month === 2 && day >= 14) || (month === 3 && day < 14)) return "ਚੇਤ";
  if ((month === 3 && day >= 14) || (month === 4 && day < 15)) return "ਵੈਸਾਖ";
  if ((month === 4 && day >= 15) || (month === 5 && day < 15)) return "ਜੇਠ";
  if ((month === 5 && day >= 15) || (month === 6 && day < 16)) return "ਹਾੜ";
  if ((month === 6 && day >= 16) || (month === 7 && day < 17)) return "ਸਾਵਣ";
  if ((month === 7 && day >= 17) || (month === 8 && day < 17)) return "ਭਾਦੋਂ";
  if ((month === 8 && day >= 17) || (month === 9 && day < 17)) return "ਅੱਸੂ";
  if ((month === 9 && day >= 17) || (month === 10 && day < 16)) return "ਕੱਤਕ";
  if ((month === 10 && day >= 16) || (month === 11 && day < 16)) return "ਮੱਘਰ";
  if ((month === 11 && day >= 16) || (month === 0 && day < 14)) return "ਪੋਹ";
  if ((month === 0 && day >= 14) || (month === 1 && day < 12)) return "ਮਾਘ";
  return "ਫੱਗਣ";
};
